///Used for dynamically determining question triggers and visibility on any page that uses generated from the question builder
var checkboxes = $("input[type='checkbox'], input[type='radio']");
var dropDownLists = $("select");
var activeTriggerQuestions = new Array();

$(document).ready(function () {
    dropDownLists.each(function () {
        checkDropDown(this);
    });
    checkboxes.each(function () {
        checkCheckbox(this);
    });
});

checkboxes.on('change',
    function () {
        var currentCheckbox = $(this);

        checkCheckbox(currentCheckbox);
    });

var previousDataTriggerItemIds;

dropDownLists.on('focus', function () {
    previousDataTriggerItemIds = $('option:selected', this).data('trigger-items');
}).change(function () {
    checkDropDown(this);

    if (previousDataTriggerItemIds === undefined) {
        return;
    }

    previousDataTriggerItemIds.forEach(function (dataTriggerItemId) {
        var questionToTriggerControl = $("#" + dataTriggerItemId);

        if (areAllTriggersOff(questionToTriggerControl)) {
            removeActiveTrigger(questionToTriggerControl);
            questionToTriggerControl.hide(500);
        }
    });

    updateExistingTriggers();
});

function removeActiveTrigger(triggerControl) {
    for (var i = 0; i < activeTriggerQuestions.length; i++) {
        if ($(triggerControl).attr("id") === activeTriggerQuestions[i].attr("id")) {
            //console.log("removing question id " + $(triggerControl).attr("id")  + " from activeTriggerQuestions.");
            activeTriggerQuestions.splice(i, 1);
        }
    }
}

function updateExistingTriggers() {
    var triggersToRemove = [];
    activeTriggerQuestions.forEach(function (questionControl) {
        //console.log("-- checking triggers for question " + $(questionControl).attr("id"));
        if (areAllTriggersOff(questionControl)) {
            //console.log("*** all triggers off for " + $(questionControl).attr("id"));
            triggersToRemove.push(questionControl);
        }
    });

    for (var i = 0; i < triggersToRemove.length; i++) {
        removeActiveTrigger(triggersToRemove[i]);
        triggersToRemove[i].hide(500);
        HideFromDropDown(triggersToRemove[i]);
    }
    updateHeader();
}
function updateHeader() {
    if ($(".total-questions-count").html() == '0') {
        $(".review-and-submit-button").toggle(true);
        $("#reviewQuestionHeading").hide();
    }
    else if (($(".answered-questions-count").html() == $(".total-questions-count").html())) {
        $(".review-and-submit-button").toggle(true);
        $("#reviewQuestionHeading").show();
    }
    else {
        $(".review-and-submit-button").toggle(false);
        $("#reviewQuestionHeading").show();
    }
}

function checkCheckbox(currentCheckbox) {
    currentCheckbox = $(currentCheckbox);

    var dataTriggerItemIds = currentCheckbox.data("trigger-items");

    if (dataTriggerItemIds != undefined) {
        dataTriggerItemIds.forEach(function (dataTriggerItemId) {
            var questionToTriggerControl = $("#" + dataTriggerItemId);
            console.log("selected:" + currentCheckbox.prop("checked"))
            if (currentCheckbox.prop("checked")) {
                activeTriggerQuestions.push(questionToTriggerControl);

                if (controlImmediatelyFollows(currentCheckbox.closest(".questionRow"),
                    questionToTriggerControl.closest(".questionRow"))) {
                    questionToTriggerControl.children(".col-md-12").addClass("col-md-push-1 col-md-11").removeClass("col-md-12");
                } else {
                    questionToTriggerControl.children(".col-md-12").removeClass("col-md-push-1 col-md-11").addClass("col-md-12");
                }

                questionToTriggerControl.show(300, function () {
                    if ($("#reviewQuestionNav").length > 0) {
                        console.log("is in review mode, need to add any triggered review questions from dropdown");
                        ShowReviewQuestionsInDropdownFromTriggeredQuestions(questionToTriggerControl);

                    }
                });
            } else if (areAllTriggersOff(questionToTriggerControl)) {
                removeActiveTrigger(questionToTriggerControl);
                questionToTriggerControl.hide(300, function () {
                    if ($("#reviewQuestionNav").length > 0) {
                        console.log("is in review mode, need to remove any triggered review questions from dropdown");
                        HideReviewQuestionsInDropdownFromUntriggeredQuestions();
                    }
                });
            }
        });
    }

    updateExistingTriggers();

}
//gets called after questions are shown due to triggers on the page
function ShowReviewQuestionsInDropdownFromTriggeredQuestions($reviewQuestion) {
    var childReviewQuestion = $reviewQuestion.find(".review-question");
    if (childReviewQuestion.length > 0) {
        var classList = $(childReviewQuestion[0]).attr('class').split(/\s+/);
        var questionId = null;
        $.each(classList, function (index, item) {
            console.log(item);
            if (item.includes("id-")) {
                questionId = item.replace("id-", "");
                console.log(questionId)
                $("#dropdown-" + questionId).show();
               // $("#reviewQuestionHeading").show();
                var currentAnswer = $(".review-question-answer-" + questionId).val();
                if (currentAnswer !== null && currentAnswer !== undefined && currentAnswer !== "" && currentAnswer.includes(" Question no longer applies.")) {
                    $(".review-question-answer-" + questionId).val(currentAnswer.replace(" Question no longer applies.", ""));
                    $(".total-questions-count").html(Number($(".total-questions-count").html()) + 1);
                }
            }
        }); 
        updateHeader()
    }
    
}
var dict = {};
//gets called after questions are hidden due to triggers on the page
function HideReviewQuestionsInDropdownFromUntriggeredQuestions() {
    $(".review-questions").not(":visible").each(function (index, element) {
        var childReviewQuestion = $(element).find(".review-question");
        if (childReviewQuestion.length > 0) {
            var classList = $(childReviewQuestion[0]).attr('class').split(/\s+/);
            console.log(element);
            var questionId = null;
            
            $.each(classList, function (index2, item) {
                console.log(item);
                if (item.includes("id-")) {
                    questionId = item.replace("id-", "");
                    console.log(questionId)
                    $("#dropdown-" + questionId).hide();
                    /*
                    if (!(item in dict)) {
                        dict[item] = 1;
                        $(".total-questions-count").html($(".total-questions-count").html() - 1);
                    }
                    */
                   // $(".total-questions-count").html($(".total-questions-count").html() - 1);
                    var currentAnswer = $(".review-question-answer-" + questionId).val();
                    if (currentAnswer === undefined || currentAnswer === "" || currentAnswer === null || !currentAnswer.includes(" Question no longer applies.")) {
                        if (currentAnswer !== undefined && currentAnswer !== "" && currentAnswer !== null) {
                   //         $(".review-question-answer-" + questionId).val(currentAnswer + " Question no longer applies.");
                        } else {
                  //          $(".review-question-answer-" + questionId).val(" Question no longer applies.");
                        }

                    }
                }
            }); 
        }
        
    });
}
function HideFromDropDown(element) {
    
        var childReviewQuestion = $(element).find(".review-question");
        if (childReviewQuestion.length > 0) {
            var classList = $(childReviewQuestion[0]).attr('class').split(/\s+/);
            console.log(element);
            var questionId = null;
            $.each(classList, function (index2, item) {
                console.log(item);
                if (item.includes("id-")) {
                    questionId = item.replace("id-", "");
                    console.log(questionId)
                    $("#dropdown-" + questionId).hide();
                    $(".total-questions-count").html($(".total-questions-count").html()-1);
                    
                    var currentAnswer = $(".review-question-answer-" + questionId).val();
                    if (currentAnswer === undefined || currentAnswer === "" || currentAnswer === null || !currentAnswer.includes(" Question no longer applies.")) {
                        if (currentAnswer !== undefined && currentAnswer !== "" && currentAnswer !== null) {
                            $(".review-question-answer-" + questionId).val(currentAnswer + " Question no longer applies.");
                        } else {
                            $(".review-question-answer-" + questionId).val(" Question no longer applies.");
                        }

                    }
                }
            });
        }

 
}
function HideReviewQuestionsInDropdownFromUntriggeredQuestionsNew(hided) {
    hided.forEach(function (index, element) {
        var childReviewQuestion = $(element).find(".review-question");
        if (childReviewQuestion.length > 0) {
            var classList = $(childReviewQuestion[0]).attr('class').split(/\s+/);
            console.log(element);
            var questionId = null;
            $.each(classList, function (index2, item) {
                console.log(item);
                if (item.includes("id-")) {
                    questionId = item.replace("id-", "");
                    console.log(questionId)
                    $("#dropdown-" + questionId).hide();
                    var currentAnswer = $(".review-question-answer-" + questionId).val();
                    if (currentAnswer === undefined || currentAnswer === "" || currentAnswer === null || !currentAnswer.includes(" Question no longer applies.")) {
                        if (currentAnswer !== undefined && currentAnswer !== "" && currentAnswer !== null) {
                            $(".review-question-answer-" + questionId).val(currentAnswer + " Question no longer applies.");
                        } else {
                            $(".review-question-answer-" + questionId).val(" Question no longer applies.");
                        }

                    }
                }
            });
        }

    });
}

function checkDropDown(dropDown) {
    var dataTriggerItemIds = $('option:selected', dropDown).data('trigger-items');

    if (dataTriggerItemIds == undefined)
        return;

    dataTriggerItemIds.forEach(function (dataTriggerItemId) {
        var questionToTriggerControl = $("#" + dataTriggerItemId);

        activeTriggerQuestions.push(questionToTriggerControl);
        questionToTriggerControl.show(500);
    });
}

function areAllTriggersOff(questionControlToCheck) {
    var result = true;
    var idToCheckFor = questionControlToCheck.attr("id");
//    var checkboxesThatTrigger = checkboxes.filter('[data-trigger-items*="' + idToCheckFor + '"]');
//    var checkedCheckboxesThatTrigger = checkboxesThatTrigger.filter(":checked");
//if (checkedCheckboxesThatTrigger.length > 0) {
//        result = false;
//    }
    checkboxes.each(function () {
        var currentCheckbox = $(this);
        var dataTriggerItemIds = currentCheckbox.data("trigger-items");

        if (dataTriggerItemIds != undefined) {
            dataTriggerItemIds.forEach(function (dataTriggerItemId) {
                if (questionControlToCheck.attr("id") === dataTriggerItemId) {
                    //console.log("Current checkbox " + currentCheckbox.attr("name") + " triggers" + dataTriggerItemId);
                    if (currentCheckbox.prop("checked")) {
                        //console.log("And is checked, some triggers still on, do not remove question.");
                        result = false;
                    }
                }
            });
        }

    });
    dropDownLists.each(function () {
        var currentDropDownList = $(this);
        var dataTriggerItemIds = $('option:selected', currentDropDownList).data('trigger-items');

        if (dataTriggerItemIds != undefined) {
            dataTriggerItemIds.forEach(function (dataTriggerItemId) {
                if (questionControlToCheck.attr("id") === dataTriggerItemId) {
                    result = false;
                }
            });
        }
    });

    return result;
}

function controlImmediatelyFollows(firstQuestionRow, secondQuestionRow) {
    var counter = 0;
    var firstQuestionRowIndex = null;
    var secondQuestionRowIndex = null;

    $(".questionRow").each(function () {
        if ($(this).find(".col-md-push-1").length == 0) {
            if ($(this).attr("id") === firstQuestionRow.attr("id")) {
                firstQuestionRowIndex = counter;
            } else if ($(this).attr("id") === secondQuestionRow.attr("id")) {
                secondQuestionRowIndex = counter;
            }

            counter++;
        }
        
    });

    if (firstQuestionRowIndex != null && secondQuestionRowIndex != null && secondQuestionRowIndex === firstQuestionRowIndex + 1) {
        return true;
    } else {
        return false;
    }
}